export const getDate = (timstamp) => {
    const fecha = new Date(timstamp);

    // Obtener año, mes y día
    const year = fecha.getUTCFullYear();
    const month = String(fecha.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() devuelve 0-11
    const day = String(fecha.getUTCDate()).padStart(2, '0');
    
    // Formatear en YYYY-MM-DD
    const fechaFormateada = `${year}-${month}-${day}`;
    
    return fechaFormateada;
}